import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { authClient } from "../lib/auth";

export const Route = createFileRoute("/_authed")({
  beforeLoad: async ({ location }) => {
    if (typeof window === "undefined") return;
    const result = await authClient.getSession().catch(() => null);
    const session = result?.data ?? null;
    if (!session) {
      throw redirect({
        to: "/sign-in",
        search: { redirect: location.href },
      });
    }
    return { session };
  },
  component: () => <Outlet />,
});
